import {
    Box,
    Text,
    Image,
    HStack,
    Switch,
    Slider,
    SliderTrack,
    SliderFilledTrack,
    SliderThumb,
    SliderMark,
    Select,
} from '@chakra-ui/react';
import { useContext } from 'react';
import MapContext from '../context/MapContext';
import dayImg from '../assets/img/day.png';
import duskImg from '../assets/img/dusk.png';
import nightImg from '../assets/img/night.png';
import hybridSatImg from '../assets/img/hybrid-sat2.png';
import hybridOffImg from '../assets/img/hybrid-off2.png';

export function MapSettings() {
    const { raster, setRaster, style, setStyle, styleSettings, setStyleSettings, depthUnits, setDepthUnits, hybrid, setHybrid } = useContext(MapContext);

    return (
        <Box p="10px" w="100%">
            <Text
                mb="10px"
                fontWeight="500"
                textTransform="uppercase"
                fontSize="12px"
                pb="1px"
                borderBottom="1px solid rgba(0,0,0,0.1)"
            >
                Color Scheme
            </Text>
            <HStack mb="20px">
                <Box
                    display="inline-box"
                    onClick={() => setStyle('day')}
                    border={style == 'day' ? '3px solid #368aeb' : '3px solid rgba(0, 0, 0, 0)'}
                    borderRadius="4px"
                    overflow="hidden"
                    w="80px"
                    cursor="pointer"
                    shadow="md"
                >
                    <Image src={dayImg} width="100px" />
                </Box>
                <Box
                    display="inline-box"
                    onClick={() => setStyle('dusk')}
                    border={style == 'dusk' ? '3px solid #368aeb' : '3px solid rgba(0,0,0,0.0)'}
                    borderRadius="4px"
                    overflow="hidden"
                    w="80px"
                    cursor="pointer"
                    shadow="md"
                >
                    <Image src={duskImg} width="100px" />
                </Box>
                <Box
                    display="inline-box"
                    onClick={() => setStyle('night')}
                    border={style == 'night' ? '3px solid #368aeb' : '3px solid rgba(0,0,0,0.0)'}
                    borderRadius="4px"
                    overflow="hidden"
                    w="80px"
                    cursor="pointer"
                    shadow="md"
                >
                    <Image src={nightImg} width="100px" />
                </Box>
            </HStack>

            <Text
                mb="10px"
                fontWeight="500"
                textTransform="uppercase"
                fontSize="12px"
                pb="1px"
                borderBottom="1px solid rgba(0,0,0,0.1)"
            >
                Imagery
            </Text>
            <HStack mb="20px">
                <Box
                    display="inline-box"
                    onClick={() => setHybrid(false)}
                    border={!hybrid ? '3px solid #368aeb' : '3px solid rgba(0, 0, 0, 0)'}
                    borderRadius="4px"
                    overflow="hidden"
                    w="80px"
                    cursor="pointer"
                    shadow="md"
                >
                    <Image src={hybridOffImg} width="100px" />
                </Box>
                <Box
                    display="inline-box"
                    onClick={() => setHybrid(true)}
                    border={hybrid ? '3px solid #368aeb' : '3px solid rgba(0,0,0,0.0)'}
                    borderRadius="4px"
                    overflow="hidden"
                    w="80px"
                    cursor="pointer"
                    shadow="md"
                >
                    <Image src={hybridSatImg} width="100px" />
                </Box>
            </HStack>
            <Text
                mt="20px"
                mb="10px"
                fontWeight="500"
                textTransform="uppercase"
                fontSize="12px"
                pb="1px"
                borderBottom="1px solid rgba(0,0,0,0.1)"
            >
                Units
            </Text>
            <Text fontWeight="400">Depth Units</Text>
            <Select size="sm" bg="white" mt="5px" value={depthUnits} onChange={(e) => setDepthUnits(e.target.value)}>
                <option value="meters">Meters</option>
                <option value="feet">Feet</option>
                <option value="fathoms">Fathoms</option>
            </Select>
            <Text
                mt="20px"
                mb="10px"
                fontWeight="500"
                textTransform="uppercase"
                fontSize="12px"
                pb="1px"
                borderBottom="1px solid rgba(0,0,0,0.1)"
            >
                Safety Contours
            </Text>
            <Text fontWeight="400">Safety Contour: {styleSettings.depthLimit.toFixed(0)}m</Text>
            <Box mt="2px" mb="10px" p="10px">
                <Slider
                    min={0}
                    max={20}
                    step={1}
                    value={styleSettings.depthLimit}
                    onChange={(val) => {
                        setStyleSettings((old) => ({
                            ...old,
                            depthLimit: val,
                        }));
                    }}
                >
                    <SliderTrack>
                        <SliderFilledTrack />
                    </SliderTrack>
                    <SliderThumb />
                </Slider>
            </Box>
            <Text
                mt="10px"
                mb="10px"
                fontWeight="500"
                textTransform="uppercase"
                fontSize="12px"
                pb="1px"
                borderBottom="1px solid rgba(0,0,0,0.1)"
            >
                Layers
            </Text>
            <Box mb="10px">
                <Switch
                    isChecked={styleSettings.showEncBoundaries}
                    onChange={() =>
                        setStyleSettings((old) => ({
                            ...old,
                            showEncBoundaries: !old.showEncBoundaries,
                        }))
                    }
                >
                    Show Chart Coverage
                </Switch>
            </Box>
            <Box mb="10px">
                <Switch
                    isChecked={styleSettings.showNoData}
                    onChange={() =>
                        setStyleSettings((old) => ({
                            ...old,
                            showNoData: !old.showNoData,
                        }))
                    }
                >
                    Show 'No Data' Overlay
                </Switch>
            </Box>
            <Text
                mt="30px"
                mb="10px"
                fontWeight="500"
                textTransform="uppercase"
                fontSize="12px"
                pb="1px"
                borderBottom="1px solid rgba(0,0,0,0.1)"
            >
                Developer
            </Text>
            <Box mb="10px">
                <Switch
                    isChecked={styleSettings.showTileBoundaries}
                    onChange={() =>
                        setStyleSettings((old) => ({
                            ...old,
                            showTileBoundaries: !old.showTileBoundaries,
                        }))
                    }
                >
                    Show Debug
                </Switch>
            </Box>
            <Box mb="10px">
                <Switch
                    isChecked={raster}
                    onChange={() =>
                        setRaster(!raster)
                    }
                >
                    Use Raster Tiles
                </Switch>
            </Box>
            {/* <Text>Data Overlays</Text>
            <Text>Units</Text> */}
        </Box>
    );
}
